import { render, staticRenderFns } from "./recruit.vue?vue&type=template&id=c486be8c&scoped=true"
import script from "./recruit.vue?vue&type=script&lang=js"
export * from "./recruit.vue?vue&type=script&lang=js"
import style0 from "./recruit.vue?vue&type=style&index=0&id=c486be8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c486be8c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TopSectionTitle: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/TopSectionTitle.vue').default,BtnReadmore: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/btn-readmore.vue').default})
